import { Card, CardContent, FormGroup, FormLabel, Typography } from '@mui/material';
import React, { useMemo, useCallback } from 'react';
import Button, { ButtonType } from '@components/topstep/button';
import HelpMessage from '@components/helpMessage';
import { useTradingAccount } from '@contexts/TradingAccountContext';
import CountdownTimer from '@/components/topstep/countdown';
import { useModal } from '@/contexts/ModalContext';
import PersonalLockoutModal from '@/components/topstep/personalLockoutModal';

type PersonalLockoutProps = {
  fullWidth?: boolean;
};

const PersonalLockout: React.FC<PersonalLockoutProps> = ({ fullWidth }: PersonalLockoutProps) => {
  const { activeTradingAccount } = useTradingAccount();
  const lockoutExpiration = activeTradingAccount?.lockoutExpiration;
  const { showModal, hideModal } = useModal();

  const lockedOutTemplate = useCallback((message, extraContent = null) => {
    return (
      <Card variant='outlined'>
        <CardContent sx={{ padding: '1.2em' }}>
          <Typography sx={{ fontSize: '1.3em', padding: 0 }}>{message} </Typography>
          {extraContent}
        </CardContent>
      </Card>
    );
  }, []);

  const lockedOutContent = useMemo(() => {
    if (activeTradingAccount.isFollower) {
      return lockedOutTemplate('Personal Lockout disabled. Follower accounts may not utilize this feature.');
    }
    if (activeTradingAccount.lockoutExpiration) {
      return lockedOutTemplate(
        'You are already locked out.',
        <p>
          <CountdownTimer targetDate={lockoutExpiration} onComplete={() => {}} />
          <Typography component='span' sx={{ fontWeight: 500, fontSize: '1.3em' }}>
            {' Remaining'}
          </Typography>
        </p>
      );
    }

    return null;
  }, [activeTradingAccount?.lockoutExpiration, activeTradingAccount?.isFollower]);

  return (
    <FormGroup sx={{ minWidth: '15em', width: '100%', maxWidth: fullWidth ? undefined : '30em' }}>
      <FormLabel sx={{ margin: '1em 0 0.5em 0' }}>
        Personal Lockout
        <HelpMessage message='Set a personal timed lockout on your account.' />
      </FormLabel>
      {lockedOutContent ? (
        lockedOutContent
      ) : (
        <Button buttonType={ButtonType.gold} style={{ color: 'white' }} onClick={() => showModal(<PersonalLockoutModal account={activeTradingAccount} onCancel={hideModal} onConfirm={hideModal} />)}>
          Set Lockout
        </Button>
      )}
    </FormGroup>
  );
};

export default PersonalLockout;
